// src/components/loadingIndicator/GlobalLoader.js
import React from "react";
import "./GlobalLoader.css";

export default function GlobalLoader() {
    return (
        <div className="global-loader-overlay">
            <div className="spinner"></div>
            <p className="loading-text">Loading...</p>
        </div>
    );
}
